import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/JiraBoardQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { getBoardQueryParams } from '@atlassian/jira-business-board-query-params/src/query-params.tsx';

export const boardEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-board-entrypoint" */ './src/JiraBoard.tsx'),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;
		const itemId = context.match.params.itemId ?? '';

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		const settings = getBoardQueryParams(context);

		return {
			queries: {
				boardQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
						viewInput: {
							jiraBoardViewQueryInput: {
								projectKeyAndItemIdQuery: {
									cloudId,
									projectKey,
									itemId,
								},
							},
							settings,
						},
						viewQueryInput: {
							projectKeyAndItemQuery: {
								cloudId,
								projectKey,
								itemId,
							},
						},
						settings,
					},
				},
			},
		};
	},
});
